import { render, staticRenderFns } from "./ModalHeaderParts.vue?vue&type=template&id=04f447b1&scoped=true"
import script from "./ModalHeaderParts.vue?vue&type=script&lang=ts"
export * from "./ModalHeaderParts.vue?vue&type=script&lang=ts"
import style0 from "./ModalHeaderParts.vue?vue&type=style&index=0&id=04f447b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f447b1",
  null
  
)

export default component.exports